'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _readOnlyOrEditableDecorator = require('../../../../components/form/readOnlyOrEditableDecorator');

var _readOnlyOrEditableDecorator2 = _interopRequireDefault(_readOnlyOrEditableDecorator);

var _UserEmailForm = require('./UserEmailForm');

var _UserEmailForm2 = _interopRequireDefault(_UserEmailForm);

var _UserEmailReadOnly = require('./UserEmailReadOnly');

var _UserEmailReadOnly2 = _interopRequireDefault(_UserEmailReadOnly);

require('./EditableUserEmail.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var EditableUserEmail = function EditableUserEmail(_ref) {
    var isEditing = _ref.isEditing,
        toggleEditing = _ref.toggleEditing;
    return _react2.default.createElement(
        'div',
        { className: 'EditableUserEmail' },
        isEditing ? _react2.default.createElement(_UserEmailForm2.default, { onSubmit: toggleEditing }) : _react2.default.createElement(_UserEmailReadOnly2.default, { toggleEditable: toggleEditing })
    );
};

// Styles


EditableUserEmail.propTypes = {
    isEditing: _propTypes2.default.bool,
    toggleEditing: _propTypes2.default.func
};

exports.default = (0, _readOnlyOrEditableDecorator2.default)(EditableUserEmail);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/editableUserEmail/EditableUserEmail.js
// module id = 2086
// module chunks = 0